import { render, staticRenderFns } from "./AddTalkgroupToUser.vue?vue&type=template&id=36941673&scoped=true"
import script from "./AddTalkgroupToUser.vue?vue&type=script&lang=js"
export * from "./AddTalkgroupToUser.vue?vue&type=script&lang=js"
import style0 from "./AddTalkgroupToUser.vue?vue&type=style&index=0&id=36941673&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36941673",
  null
  
)

export default component.exports